module.exports = __webpack_public_path__ + "img/RTX.346b87e2.png";